import { decoratorAsyncCache } from "@/utils/decorator";
import request from "@/utils/request";

// 获取分期产品授信额度跳转页面
interface ILogin {
  mobile: string;
  code: string;
  channelCode: string;
  ticket?: string
  loanCashType?:number //是否是现金贷用户，1-是，0-不是
}


export interface MemberInstallmentProductCredit {
  quotaTotalLimit: number;
  usedQuotaLimit: number;
  creditStatus: number;
  creditTime: string;
}

export const marketing_getInstallmentProductCreditUrl = (
  params?: any,
  headers?: any
): Promise<any> => {
  return request({
    url: "/marketing/getInstallmentProductCreditUrl",
    method: "get",
    params: params,
    headers,
  });
};
export interface MatchProductRequest {
  channelCode: string;
}
export interface MatchProductResponse {
  id: string;
  productLogo: string;
  showProductName: string;
  cooperationType: number;
  serialNo: string;
  planCode: string;
}

// 获取下游导流H5产品列表
export const marketing_matchProduct = (param: MatchProductRequest): Promise<MatchProductResponse[]> => {
  return request({
    url: "/marketing/matchProduct",
    method: "post",
    data: param,
  });
};

// 点击申请下游导流产品
export const marketing_clickApplyProduct = (): Promise<any> => {
  return request({
    url: "/marketing/clickApplyProduct",
    method: "post",
  });
};
export interface ApplyProductRequest {
  downStreamProductId: string;
  channelCode: string;
  serialNo: string;
  planCode: string;
}
export interface ApplyProductResponse {
  applyStatus: number;
  targetUrl: string;
}

// 点击申请下游导流产品
export const marketing_applyProduct = (
  param: ApplyProductRequest
): Promise<ApplyProductResponse> => {
  return request({
    url: "/marketing/applyProduct",
    method: "post",
    data: param,
  });
};

export interface ProtocolRequest {
  channelCode: string
  downStreamProductId: string
}
export interface ProtocolResponse {
  url: string;
  protocolName: string;
  content?: string;
}
// 获取半流程协议
export const marketing_protocol = (param: ProtocolRequest): Promise<ProtocolResponse[]> => {
  return request({
    url: "/marketing/protocol",
    method: "post",
    data: param,
  });
};


export interface ProtocolBatchRequest {
  downStreamProductIdList: string[];
}
export interface ProtocolBatchResponse {
  url: string;
  protocolName: string;
  content?: string;
}
// 批量获取半流程协议
export const marketing_batchProtocol = (param: ProtocolBatchRequest): Promise<{[key: string]:ProtocolBatchResponse[]}> => {
  return request({
    url: "/marketing/batch/protocol",
    method: "post",
    data: param,
  });
};
export interface CreditStatusRequest {
  downStreamProductId:string
  channelCode: string
  serialNo: string
}
export interface CreditStatusResponse {
  creditStatus: number;
  targetUrl: string;
}
// 获取半流程跳转地址
export const marketing_creditStatus = (param: CreditStatusRequest): Promise<CreditStatusResponse> => {
  return request({
    url: "/marketing/creditStatus",
    method: "post",
    data: param || {},
  });
};

// 是否匹配多个产品
export const marketing_multipleMatch = (): Promise<boolean> => {
  return request({
    url: "/marketing/multipleMatch",
    method: "get",
    data: {},
  });
};

export interface BatchApplyProductRequest {
  downStreamProductId: string;
  channelCode: string;
  planCode: string;
  serialNo: string;
}
export interface BatchApplyProductResponse {
  id: string;
  applyStatus: number;
  targetUrl: string;
  cooperationType: number;
  serialNo: string;
  productLogo: string;
  showProductName: string;
}

// 批量申请下游导流产品
export const marketing_batchApplyProduct = (param:BatchApplyProductRequest[]): Promise<BatchApplyProductResponse[]> => {
  return request({
    url: "/marketing/batch/applyProduct",
    method: "post",
    data: param || {},
  });
};

export const login = (param: ILogin, headers?: any): Promise<any> => {
  return request({
    url: "/sso/login",
    method: "post",
    data: param,
    headers,
  });
};

export const sendPhoneVerifyCode = (param: number): Promise<any> => {
  return request({
    url: "/sso/login/sendPhoneVerifyCode",
    method: "post",
    data: {
      mobile: param,
    },
  });
};

export const getHotProductList = (query: any): Promise<any> => {
  return request({
    url: "/home/hotProductList",
    method: "get",
    params: query,
  });
};

export interface applyProductRequest {
  downStreamProductId: string;
  channelCode: string;
  serialNo: number;
  planCode: number;
}
export interface ApplyProductResponse {
  id: number;
  applyStatus: number;
  targetUrl: string;
  cooperationType: number;
  serialNo: string;
  productLogo: string;
  showProductName: string;
}

export const applyProduct = (param: applyProductRequest): Promise<ApplyProductResponse> => {
  return request({
    url: "/marketing/clickApplyProduct",
    method: "post",
    data: param,
  });
};

export const member_getMemberInstallmentProductCredit = (
  query: any
): Promise<any> => {
  return request({
    url: "/member/getMemberInstallmentProductCredit",
    method: "get",
    params: query,
  });
};
export const member_getMemberInfo = (): Promise<any> => {
  return request({
    url: "/sso/info",
    method: "get",
    params: {},
  });
};

export const marketing_getThresholdStatus = (query: any): Promise<any> => {
  return request({
    url: "/marketing/getThresholdStatus",
    method: "get",
    params: query,
  });
};

export const aliyun_oss_policy = (params: {
  image: string;
  isPrivate: boolean;
}): Promise<any> => {
  return request({
    url: "/aliyun/oss/policy",
    method: "get",
    params,
  });
};

export const aliyun_oss_temp_link = (params: { key: string }): Promise<any> => {
  return request({
    url: "/aliyun/oss/temp/link",
    method: "get",
    params,
  });
};

export type sso_info_response = {
  /**
   * 注册时间
   */
  createTime?: string;
  /**
   * 头像
   */
  icon?: string;
  /**
   * 会员ID
   */
  id?: number;
  /**
   * 手机号码
   */
  mobile?: string;
  /**
   * 昵称
   */
  nickname?: string;
  /**
   * 用户名
   */
  username?: string;
  /**
   * 是否新用户
   */
  newUser?: number
  /**
   * 注册渠道编码
   */
  registerChannelCode?: string;
  /** 
   * 登录方式
   */
  loginType?:number
};

export const sso_info = (): Promise<sso_info_response> => {
  return request({
    url: "/sso/info",
    method: "get",
  });
};

export type SysAreaVO = {
  adcode?: string; // 地址编码
  childrenNum?: number; // 子节点数量
  id?: number; // 主键
  level?: string; // 层级
  name?: string; // 地址名称
  pcode?: string; // 父编码
  pid?: number;
  [property: string]: any;
};
export type dataDict_listArea_child_response = SysAreaVO[];

// 行政区划查询
export const dataDict_listArea_child = (params: { pid: number }) => {
  return request<dataDict_listArea_child_response>({
    url: "/dataDict/listArea/child",
    method: "get",
    params,
  })
}
export const dataDict_listArea_child_decoratorAsyncCache = decoratorAsyncCache(dataDict_listArea_child)

// 前筛分检查
export const getPreAuditCheck = (channelCode: string) => {
  return request<{supported: boolean}>({
    url: `/pre-audit/check/${channelCode}`,
    method: 'get',
  })
}

// 前筛分查询
export const getPreAuditQuery = (params: {channelCode: string, mobile: string}) => {
  return request<{result: number
  }>({
    url: `/pre-audit/query`,
    method: 'post',
    data: params,
  })
}


export interface DirectFlowRequest {
  mobileMD5: string;
  adChannelCode: string;
  serialNo: string;
}
// 获取直连中转跳转链接
export const getDirectFlowUrl = (data:DirectFlowRequest) => {
  return request<string>({
    url: `/marketing/directFlow`,
    method: 'post',
    data,
  })
}


